import { createContext } from 'react'




const PosSessionContext = createContext();


export default PosSessionContext; 